import { Component, Input } from '@angular/core';
import { InvoiceDetailService } from '../services/invoice.detail.service';
import { ActivatedRoute } from '@angular/router';
import { InvoiceService } from '../services/invoice.service';
import { Invoice } from '../models/invoice.model';
import { NotificationService } from '../services/notification.service';



@Component({
  selector: 'app-invoice-detail',
  templateUrl: './invoice-detail.component.html'
})
export class InvoiceDetailComponent {
  

  constructor(private activatedRoute: ActivatedRoute, public invoiceDetailService: InvoiceDetailService, public service: InvoiceService, private notificationService: NotificationService) {

  }

  model: Invoice;
  id: string;

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.id = params.get('id');

      this.invoiceDetailService.invoiceID = parseInt(this.id);

      this.service.get(this.id).subscribe(
        res => {
          this.service.model = res as Invoice;
        },
        err => { console.log(err); this.notificationService.notifyFailure(); }
      );
    });
  }


}
